<template>
  <ChatMessageTemplateModalStructure
    :loading="loading"
    :noTemplate="selectedTemplate == null"
  >
    <template #header>
      <ChatMessageTemplateHeader
        @close="emit('close')"
        showCreate
        @create="$emit('changeMode', 'create')"
      >
        テンプレートを利用
      </ChatMessageTemplateHeader>
    </template>

    <template #list>
      <ChatMessageTemplateTemplateList :list="data" v-model="_selectedGuid" />
    </template>

    <template #detail>
      <ChatMessageTemplateDetailView
        v-if="selectedTemplate != null"
        :template="selectedTemplate"
        :disableInsert="disableInsert"
        @insert="handleInsert"
        @changeMode="delegateChangeMode"
      />
    </template>
  </ChatMessageTemplateModalStructure>
</template>

<script lang="ts" setup>
import { computed, watch } from 'vue'

import ChatMessageTemplateTemplateList from './ChatMessageTemplateTemplateList.vue'
import ChatMessageTemplateHeader from './ChatMessageTemplateHeader.vue'
import ChatMessageTemplateDetailView from './ChatMessageTemplateDetailView.vue'
import ChatMessageTemplateModalStructure from './ChatMessageTemplateModalStructure.vue'
import { useChatMessageTemplate } from './useChatMessageTemplate'

import type { ChatMessageTemplate } from '@/types/app'
import type { ChatMessageTemplateModalMode } from './types'

const props = defineProps<{
  selectedGuid: Maybe<ChatMessageTemplate['guid']>
  disableInsert: boolean
}>()

const emit = defineEmits<{
  (event: 'close'): void
  (
    event: 'update:selectedGuid',
    value: Maybe<ChatMessageTemplate['guid']>
  ): void
  (event: 'insert', template: ChatMessageTemplate): void
  (event: 'changeMode', value: ChatMessageTemplateModalMode): void
}>()

const _selectedGuid = computed({
  get: () => props.selectedGuid,
  set: (value: Maybe<ChatMessageTemplate['guid']>) => {
    emit('update:selectedGuid', value)
  },
})

const { loading, data, map } = useChatMessageTemplate()
const selectedTemplate = computed(() =>
  props.selectedGuid != null ? map.value.get(props.selectedGuid) : null
)

// NOTE: リストの自動選択
watch(
  [loading, data],
  ([_loading, _data]) => {
    if (props.selectedGuid != null || _loading || _data.length === 0) {
      return
    }
    _selectedGuid.value = _data[0].guid
  },
  { immediate: true }
)

const handleInsert = () => {
  if (selectedTemplate.value == null) {
    return
  }
  emit('insert', selectedTemplate.value)
}

const delegateChangeMode = (mode: ChatMessageTemplateModalMode): void => {
  emit('changeMode', mode)
}
</script>
